module.exports = "/public/images/7f9a9016b4cb290c5fcd938238186582.png";